module.exports = __webpack_public_path__ + "assets/nodata_dark.svg";